// base64url primitives. `btoa`/`atob` only speak Latin-1 — one byte per code unit —
// so anything carrying user text (a search fingerprint inside a page cursor) has to be
// transcoded through UTF-8 first or `btoa` throws InvalidCharacterError on the first
// code point above U+00FF. The `-`/`_`/no-padding alphabet keeps the output safe to drop
// into a URL or a query parameter unescaped.

export function base64UrlFromBytes(bytes: Uint8Array): string {
  let binary = "";
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export function bytesFromBase64Url(encoded: string): Uint8Array {
  const binary = atob(encoded.replace(/-/g, "+").replace(/_/g, "/"));
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  return bytes;
}

/** Encodes arbitrary text, including astral-plane characters, as base64url. */
export function base64UrlOfUtf8(text: string): string {
  return base64UrlFromBytes(new TextEncoder().encode(text));
}

/** Throws on a malformed base64url payload or on invalid UTF-8; callers decide. */
export function utf8FromBase64Url(encoded: string): string {
  return new TextDecoder("utf-8", { fatal: true }).decode(bytesFromBase64Url(encoded));
}
